<template>
  <div>
    <AppNav />
    <v-main>
      <HomePage v-if="$store.getters['account/loggedin']" />
      <v-container v-else fluid grid-list-md>
        <h1>Por favor, faça login para usar o sistema.</h1>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import AppNav from '../components/AppNav';
import HomePage from '../components/HomePage';

export default {
  components: {
    AppNav,
    HomePage,
  },

  computed: mapState([
    'account'
  ]),
};
</script>
